/** @format */

import { reduxForm, Form, Field, reset } from "redux-form";
import RenderField from "../form-components/RenderField";
import {
  Row,
  Col,
  Card,
  Button,
  CardHeader,
  CardBody,
  Label,
  Input,
  Alert,
  Tooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import axios from "axios";
import requests from "../utils/Requests";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import TopNav from "../pages/global-components/top_nav";
import Subscribe from "../pages/global-components/subscribe";
import Footer from "../pages/global-components/footer";
import DynamicBanner from "../pages/global-components/dynamic_banner";
import Attractionbygroup from "./attractionByGroup";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import encryptStorage from "../utils/Encryptstorage";
import { usData } from "../utils/RdData";
const AfterSubmit = (result, dispatch) => {
  dispatch(reset("TicketBookingForm"));
  //window.location.href = "/success";
};


const Packdetailapi = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const xmlResponce = usData();

  const hConfig = {
    headers: {
      "access-Key": xmlResponce,
    },
  };

  console.log(
    "xmlResponcexmlResponcexmlResponcexmlResponcexmlResponcexmlResponce======>",
    xmlResponce
  );
  let history = useHistory();
  const { id } = useParams();
  let publicUrl = process.env.PUBLIC_URL + "/";
  const [agency, setagency] = useState(0);
  const [agencyuser, setagencyuser] = useState(0);
  const [userId, setuserId] = useState(0);
  let addonget = { attractionId: id };
  const [LoggedIn, setLoggedIn] = useState();
  const [bookingAddon, setbookingAddon] = useState([]);
  const [tourpack, setTourpack] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [adultfare, setadultfare] = useState(0);
  const [childfare, setchildfare] = useState(0);
  const [youthfare, setyouthfare] = useState(0);
  const [infantFare, setInfantFare] = useState(0);
  const [numOfAdult, setnumOfAdult] = useState(0);
  const [numOfChild, setnumOfChild] = useState(0);
  const [numOfYouth, setnumOfYouth] = useState(0);

  const [numOfInfant, setumOfInfant] = useState(0);
  const [addonPrice, setaddonPrice] = useState(0);
  const [b2cUser, setb2cUser] = useState(0);
  const [OpenTicket, setOpenTicket] = useState("");
  const [UserCredit, setUserCredit] = useState(1);
  const formValues = useSelector((state) => state?.form?.TicketBookingFormapi?.values || {});

  //for Form Submit
  const [ticketTypeList, setTicketTypeList] = useState([]);
  const [insuffBal, setinsuffBal] = useState(0);
  const [paymentSelection, setpaymentSelection] = useState(0);

  const [userdata, setuserdata] = useState([]);

  const [seletedTicketId, setseletedTicketId] = useState();
  const [selectedTicketType, setSelectedTicketType] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [isLoadingTimeSlots, setIsLoadingTimeSlots] = useState(false);
  const [selectedTravelDate, setSelectedTravelDate] = useState(null);
  const [ticketTypesForSlot, setTicketTypesForSlot] = useState([]);
  const [isAdultAvailableForSlot, setIsAdultAvailableForSlot] = useState(false);
  const [isChildAvailableForSlot, setIsChildAvailableForSlot] = useState(false);
  const [showQtyBelowSlots, setShowQtyBelowSlots] = useState(false);
  const [slotAdultPrice, setSlotAdultPrice] = useState(null);
  const [slotChildPrice, setSlotChildPrice] = useState(null);
  const [selectedSlotEventId, setSelectedSlotEventId] = useState(null);

  const [showOption, setShowOption] = useState(false);
  const [splError, setsplError] = useState();
  let login = sessionStorage.getItem("isLoggedIn");
  useEffect(() => {
    console.log("thiravugol", xmlResponce);
    encryptStorage.removeItem("DFuck");
    encryptStorage.removeItem("url");
    encryptStorage.removeItem("suckapi");
    encryptStorage.removeItem("firstSubmitForBooking");
    encryptStorage.removeItem("mofForBooking");
    window.scrollTo(0, 0);

    if (login == "yes") {
      const enl = encryptStorage.getItem("enl"); //obj //agency.agencyId
      let urlObject = JSON.parse(enl);
      console.log("urlObject", urlObject);
      setuserdata(urlObject);
      //b2b
      if (urlObject.b2b == true) {
        if (urlObject.agency.superAdmin === true) {
          // getAllAgentList();
        }
        props.initialize({
          attractionsId: id,
          bookPaymentMode: 1,
          bookMobileNumber: urlObject.agency.agencyPhoneNumber,
          bookCustomerEmail: urlObject.agency.agencyEmail,
          //agencyEmail
        });
        // setuserEmail(urlObject.agency.agencyEmail);
        let agency = urlObject.agency.agencyId;

        setsplError(urlObject.agency.agencyPassword);
        setagency(agency);
        getTourDeail(agency, 0);
        setLoggedIn(1);
      } else if (urlObject.b2bUser == true) {
        props.initialize({
          attractionsId: id,
          bookPaymentMode: 1,
          //  bookMobileNumber: urlObject.agency.agencyPhoneNumber,
        });
        let agencyuser = urlObject.agencyUser.agencyUserId;
        setsplError(urlObject.agencyUser.userPassword);
        setagencyuser(agencyuser);
        getTourDeail(0, agencyuser);
        setLoggedIn(1);
      } else {
        props.initialize({
          attractionsId: id,
          bookPaymentMode: 1,
          //  bookMobileNumber: urlObject.agency.agencyPhoneNumber,
        });
        setuserId(urlObject.customer.customerId);
        setb2cUser(1);
        getTourDeail(0, 0);
        setLoggedIn(1);
        setOpenTicket(2);
        //  props.initialize({});
      }
    } else {
      setOpenTicket(2);
      getTourDeail(0, 0);
      setLoggedIn(0);
      props.initialize({
        attractionsId: id,
        bookPaymentMode: 1,
        // bookMobileNumber: "lahdiuad",
      });
    }

   
    getBannerAddons();
 

    // checkKey();
  }, []);

  const logout = (e) => {
    sessionStorage.clear();
    window.location.reload();
    // console.log("clear");
    window.location.href = "/";
  };

  let atID;
  const getTourDeail = async (b2bid, b2buserid) => {
    await axios
      .post(requests.getAttractionDetails, {
        attractionsId: id,
        agencyId: b2bid,
        agencyUserId: b2buserid,
        currencyCode: "",
      })
      .then((res) => {
        setTourpack(res.data);
        console.log(res.data);
        //attConnectWithApi
        // const [OpenTicket, setOpenTicket] = useState(1);

        if (res.data.alertUser === true) {
          Swal.fire("Information!", `${res.data.alertMessage}`, "info");
        }


        setisLoading(false);
        // settktfare(tourpack.price)
        // console.log(res.data);
        if (LoggedIn == 1) {
          if (userdata.b2b == true || userdata.b2bUser == true) {
            setadultfare(res.data.b2bAdultPrice);
            setchildfare(res.data.b2bChildPrice);
            setInfantFare(res.data.b2bInfantPrice);
          } else {
            setadultfare(res.data.b2cAdultPrice);
            setchildfare(res.data.b2cChildPrice);
            setInfantFare(res.data.b2cInfantPrice);
          }
        } else {
          setadultfare(res.data.b2cAdultPrice);
          setchildfare(res.data.b2cChildPrice);
          setInfantFare(res.data.b2cInfantPrice);
        }
        atID = res.data.attGroup;
        getAttAllByGroup(atID);
        sessionStorage.setItem("attname", res.data.attName);
        // Fetch ticket types after tour pack details are loaded
        // Use attractionsId from the attraction details object
        getTicketTypeList(res.data.attractionsId);
        // Ensure form uses the attractionsId from the loaded attraction details
        if (props && typeof props.change === "function" && res.data.attractionsId) {
          props.change("attractionsId", String(res.data.attractionsId));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [attractionList, setattractionList] = useState([]);
  // let GroupId = { attGroup: tourpack.attGroup };
  const [AttGrouFilter, setAttGrouFilter] = useState([]);
  const getAttAllByGroup = async (gId) => {
    await axios
      .post(requests.getattractionallbygroup, { attGroup: gId })
      .then((res) => {
        setattractionList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
 


  const [bannerAddOn, setbannerAddOn] = useState();
  const [isBannerLoading, setisBannerLoading] = useState(true);
  const getBannerAddons = async () => {
    await axios
      .post(requests.getaddonbannerlist, addonget)
      .then((res) => {
        setbannerAddOn(res.data);
        setisBannerLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Fetch ticket type list by attraction
  const getTicketTypeList = async (attractionId) => {
    try {
      const response = await axios.post(requests.getTicketTypeListByAttraction, {
        ttAttractionId: attractionId || id, // Use attractionId from tourpack if available, otherwise fallback to id
        platformId: 1,
      });
      
      if (response.data && Array.isArray(response.data)) {
        // Transform the response to match the format expected by renderOptionField
        const ticketTypeOptions = response.data.map((ticket) => ({
          value: ticket.ticketTypeId,
          name: ticket.ttTicketType,
          // Store full ticket data for later use if needed
          fullData: ticket,
        }));
        setTicketTypeList(ticketTypeOptions);
      }
    } catch (error) {
      console.error("Error fetching ticket types:", error);
      setTicketTypeList([]);
    }
  };

  // Fetch Burj Khalifa time slots
  const getBurjKhalifaTimeSlots = async (travelDate, productId) => {
    console.log("getBurjKhalifaTimeSlots called with:", { travelDate, productId });
    
    if (!travelDate || !productId) {
      console.log("Missing travelDate or productId, returning early");
      setTimeSlots([]);
      return;
    }

    setIsLoadingTimeSlots(true);
    try {
      // Format date to "YYYY-MM-DD HH:mm:ss" format
      const formattedDate = dayjs(travelDate).format("YYYY-MM-DD");
      const startDateTime = `${formattedDate} 00:00:00`;
      const endDateTime = `${formattedDate} 23:59:00`;

      console.log("Calling API with:", {
        ProductId: productId,
        StartDateTime: startDateTime,
        EndDateTime: endDateTime,
        url: requests.getBurjKhalifaTimeSlot
      });

      const response = await axios.post(requests.getBurjKhalifaTimeSlot, {
        ProductId: productId,
        StartDateTime: startDateTime,
        EndDateTime: endDateTime,
      });
      
      console.log("Time slot API response:", response.data);

      if (response.data && response.data.getTimeSlotDto) {
        const timeSlotData = response.data.getTimeSlotDto.ResponseData;
        if (timeSlotData && timeSlotData.TimeSlots && Array.isArray(timeSlotData.TimeSlots)) {
          setTimeSlots(timeSlotData.TimeSlots);
        } else {
          setTimeSlots([]);
        }
      } else {
        setTimeSlots([]);
      }
    } catch (error) {
      console.error("Error fetching time slots:", error);
      setTimeSlots([]);
    } finally {
      setIsLoadingTimeSlots(false);
    }
  };

  // Handle travel date change
  const handleTravelDateChange = (date) => {
    console.log("=== handleTravelDateChange called ===");
    console.log("Travel date:", date);
    console.log("Selected ticket type state:", selectedTicketType);
    console.log("Selected ticket ID:", seletedTicketId);
    console.log("Ticket type list length:", ticketTypeList.length);
    
    if (!date) {
      console.log("No date provided, clearing time slots");
      setTimeSlots([]);
      return;
    }
    
    setSelectedTravelDate(date);
    
    // Get productId from selected ticket type - check multiple possible locations
    let productId = null;
    
    // First, try to get from selectedTicketType state
    if (selectedTicketType && selectedTicketType.fullData) {
      const fullData = selectedTicketType.fullData;
      productId = fullData.productId || fullData.ProductId || fullData.productid;
      
      console.log("Checking selectedTicketType.fullData:", fullData);
      console.log("ProductId from selectedTicketType:", productId);
    }
    
    // If not found in state, try to find from ticketTypeList using the currently selected ticketTypeId
    if (!productId && seletedTicketId) {
      console.log("Looking up ticket type by seletedTicketId:", seletedTicketId);
      const currentTicketType = ticketTypeList.find(
        (ticket) => {
          const ticketValue = ticket.value;
          const selectedId = seletedTicketId;
          const matches = ticketValue === selectedId || 
                         ticketValue === String(selectedId) || 
                         String(ticketValue) === String(selectedId);
          return matches;
        }
      );
      
      if (currentTicketType) {
        console.log("Found ticket type from seletedTicketId:", currentTicketType);
        if (currentTicketType.fullData) {
          const fullData = currentTicketType.fullData;
          productId = fullData.productId || fullData.ProductId || fullData.productid;
          console.log("ProductId from looked up ticket type:", productId);
          
          // Also update selectedTicketType state for future use
          if (!selectedTicketType) {
            setSelectedTicketType(currentTicketType);
          }
        }
      } else {
        console.log("Ticket type not found in list for ID:", seletedTicketId);
      }
    }
    
    console.log("Final ProductId found:", productId);
    console.log("Will call API:", productId && productId > 0);
    
    if (productId && productId > 0) {
      console.log("Calling getBurjKhalifaTimeSlots with date:", date, "productId:", productId);
      getBurjKhalifaTimeSlots(date, productId);
    } else {
      console.warn("ProductId not found or invalid. Ticket type list:", ticketTypeList);
      console.warn("Make sure a ticket type with productId is selected before selecting date.");
      setTimeSlots([]);
    }
  };

  // Handle ticket type change
  const handleTicketTypeChange = (ticketTypeId) => {
    console.log("Ticket type changed:", ticketTypeId);
    setseletedTicketId(ticketTypeId);
    // Sync redux-form field to ensure payload reads the selected value
    if (props && typeof props.change === "function") {
      props.change("ticketTypeId", String(ticketTypeId || ""));
    }
    
    // Find the selected ticket type from the list
    const ticketType = ticketTypeList.find((ticket) => ticket.value === ticketTypeId || ticket.value === String(ticketTypeId));
    if (ticketType) {
      console.log("Found ticket type:", ticketType);
      console.log("Full data:", ticketType.fullData);
      setSelectedTicketType(ticketType);
      
      // Get productId from various possible locations
      const fullData = ticketType.fullData || {};
      const productId = fullData.productId || fullData.ProductId || fullData.productid;
      
      console.log("ProductId from ticket type:", productId);
      
      // If travel date is already selected, fetch time slots
      if (selectedTravelDate && productId && productId > 0) {
        getBurjKhalifaTimeSlots(selectedTravelDate, productId);
      }
    } else {
      console.log("Ticket type not found in list");
      setSelectedTicketType(null);
      setTimeSlots([]);
    }
  };

  // Format time slot display (e.g., "07:00 - 07:30")
  const formatTimeSlot = (startDateTime, endDateTime) => {
    try {
      const startTime = dayjs(startDateTime).format("HH:mm");
      const endTime = dayjs(endDateTime).format("HH:mm");
      return `${startTime} - ${endTime}`;
    } catch (error) {
      return startDateTime + " - " + endDateTime;
    }
  };

  // Fetch ticket types for a selected time slot
  const getBurjKhalifaTicketTypes = async (slot) => {
    try {
      // productId from selected ticket type
      let productId = null;
      if (selectedTicketType && selectedTicketType.fullData) {
        const fd = selectedTicketType.fullData;
        productId = fd.productId || fd.ProductId || fd.productid;
      }
      if (!productId) {
        console.warn("ProductId missing for ticket types call");
        return;
      }

      const payload = {
        TimeSlot: {
          ProductId: productId,
          EventID: slot.EventID,
          StartDateTime: slot.StartDateTime,
          EndDateTime: slot.EndDateTime,
          ticketTypeId:selectedTicketType?.value,
          agencyId: agency,
          agencyUserId:agencyuser
        },
      };

      const res = await axios.post(requests.getBurjKhalifaTicketTypes, payload);
      const dto = res?.data?.getTicketTypesDto?.ResponseData;
      if (dto && Array.isArray(dto.Tickets)) {
        setTicketTypesForSlot(dto.Tickets);
        // detect adult/child availability by TicketGroup
        const hasAdult = dto.Tickets.some((t) => (t.TicketGroup || "").toLowerCase() === "adult");
        const hasChild = dto.Tickets.some((t) => (t.TicketGroup || "").toLowerCase() === "child");
        setIsAdultAvailableForSlot(hasAdult);
        setIsChildAvailableForSlot(hasChild);
        // set prices for display
        const adultT = dto.Tickets.find((t) => (t.TicketGroup || "").toLowerCase() === "adult");
        const childT = dto.Tickets.find((t) => (t.TicketGroup || "").toLowerCase() === "child");
        setSlotAdultPrice(adultT ? adultT.TicketPrice : null);
        setSlotChildPrice(childT ? childT.TicketPrice : null);
        setShowQtyBelowSlots(true);
      } else {
        setTicketTypesForSlot([]);
        setIsAdultAvailableForSlot(false);
        setIsChildAvailableForSlot(false);
        setShowQtyBelowSlots(false);
        setSlotAdultPrice(null);
        setSlotChildPrice(null);
      }
    } catch (e) {
      console.error("Error fetching ticket types:", e);
      setTicketTypesForSlot([]);
      setIsAdultAvailableForSlot(false);
      setIsChildAvailableForSlot(false);
      setShowQtyBelowSlots(false);
      setSlotAdultPrice(null);
      setSlotChildPrice(null);
    }
  };

  // Custom render function for ticket type field with onChange tracking
  const renderTicketTypeField = (props) => {
    const { input, label, customfeild } = props;
    const handleChange = (e) => {
      const selectedValue = e.target.value;
      input.onChange(e); // Call redux-form's onChange
      handleTicketTypeChange(selectedValue); // Call custom handler
    };

    return (
      <>
        <div className="single-widget-search-input-title">
          <i className="" /> {label}
        </div>
        <Input {...input} type="select" placeholder={label} onChange={handleChange}>
          <option value="">Select {label}</option>
          {customfeild.map((optvalue, key) => (
            <option key={key} name={optvalue.value} value={optvalue.value}>
              {optvalue.name}
            </option>
          ))}
        </Input>
        <div className="err-msg">{props.meta.touched && props.meta.error && <span>{props.meta.error}</span>}</div>
      </>
    );
  };

  // Custom render function for date picker with onChange tracking
  const renderDatePickerWithTimeSlot = (props) => {
    const { input, label, minDate } = props;
    
    const handleDateChange = (date) => {
      console.log("DatePicker onChange triggered with date:", date);
      console.log("Current selectedTicketType:", selectedTicketType);
      console.log("Current seletedTicketId:", seletedTicketId);
      
      // Update redux-form value first
      input.onChange(date);
      
      // Call our handler immediately (don't use setTimeout, it causes issues)
      if (date) {
        handleTravelDateChange(date);
      } else {
        setTimeSlots([]);
        setSelectedTravelDate(null);
      }
    };

    return (
      <div>
        <div className="single-widget-search-input-title">
          <i className="" /> {label}
        </div>
        <DatePicker
          className="plus-icon form-control"
          dateFormat="yyyy/MM/dd"
          selected={input.value || null}
          onChange={handleDateChange}
          minDate={minDate}
          disabledKeyboardNavigation
          placeholderText="Select date"
          showPopperArrow={false}
        />
        <div className="err-msg">{props.meta.touched && props.meta.error && <span>{props.meta.error}</span>}</div>
      </div>
    );
  };

  // Consolidated Book Now handler
  const handleBookNow = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    // Redirect to login if not logged in
    const currentLogin = sessionStorage.getItem("isLoggedIn");
    if (currentLogin !== "yes") {
      history.push("/login-page");
      return;
    }
    // Validate user context object as well
    let enlStr;
    try { enlStr = encryptStorage.getItem("enl"); } catch {}
    if (!enlStr) { history.push("/login-page"); return; }
    let urlObject;
    try { urlObject = JSON.parse(enlStr); } catch { urlObject = null; }
    if (!urlObject) { history.push("/login-page"); return; }

    const guestName = formValues?.bookCustomerName || formValues?.firstName || "";
    const guestEmail = formValues?.bookCustomerEmail || "";
    const guestMobile = formValues?.bookMobileNumber || "";

    if (!guestName) { Swal.fire("Error", "Guest name is required", "error"); return; }
    if (!guestEmail) { Swal.fire("Error", "Guest email is required", "error"); return; }
    if (!guestMobile) { Swal.fire("Error", "Guest mobile is required", "error"); return; }
    if (!selectedSlotEventId) { Swal.fire("Error", "Please select a time slot", "error"); return; }
    if (!isAdultAvailableForSlot && !isChildAvailableForSlot) { Swal.fire("Error", "No tickets available for selected slot", "error"); return; }
    if (isAdultAvailableForSlot && (!numOfAdult || parseInt(numOfAdult) <= 0)) { Swal.fire("Error", "Adult quantity is required", "error"); return; }

    const slot = timeSlots.find(s => s.EventID === selectedSlotEventId);
    if (!slot) { Swal.fire("Error", "Invalid time slot selection", "error"); return; }

    const ticketsPayload = [];
    const adultTicket = ticketTypesForSlot.find(t => (t.TicketGroup || "").toLowerCase() === "adult");
    const childTicket = ticketTypesForSlot.find(t => (t.TicketGroup || "").toLowerCase() === "child");
    if (adultTicket && (parseInt(numOfAdult) || 0) > 0) {
      ticketsPayload.push({ ...adultTicket, Quantity: parseInt(numOfAdult) });
    }
    if (childTicket && (parseInt(numOfChild) || 0) > 0) {
      ticketsPayload.push({ ...childTicket, Quantity: parseInt(numOfChild) });
    }
    if (ticketsPayload.length === 0) { Swal.fire("Error", "Please enter at least one ticket quantity", "error"); return; }

    const productId = (selectedTicketType?.fullData?.productId || selectedTicketType?.fullData?.ProductId || selectedTicketType?.fullData?.productid);
    const payload = {
      GuestName: guestName,
      GuestEmail: guestEmail,
      GuestMobile: guestMobile,
      TimeSlot: {
        ProductId: productId,
        EventID: slot.EventID,
        StartDateTime: slot.StartDateTime,
        EndDateTime: slot.EndDateTime,
      },
      Tickets: ticketsPayload,
    };

    try {
      const res = await axios.post(requests.getBurjKhalifaSaveTicket, payload);
      const ok = res?.data?.getSaveTicketDto?.ResultStatus === true;
      if (ok) {
        encryptStorage.setItem("burjSavePreview", JSON.stringify({ payload, response: res.data }));
        history.push("/burj-save-confirmation");
      } else {
        Swal.fire("Error", "Could not save ticket. Please try again.", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Failed to call Save Ticket API", "error");
    }
  };

 


 

  // get all agency user to list out for booking super admin

  

  


  const [tempErr, settempErr] = useState(false);

  const checkboxvalues = (e) => {
    //checkAddonBarcodeAvailability

    settempErr(false);
    //console.log("e", e.target.value);

    let val = e.target.id;
    let newprice = e.target.value;

    let tempAddon = [...bookingAddon];

    if (e.target.checked == true) {
      let finalprice = Number(addonPrice) + Number(newprice);
      setaddonPrice(finalprice);
      let tempEle = { addonId: val };
      tempAddon.push(tempEle);
      setbookingAddon(tempAddon);

      // console.log("tempAddon", tempAddon);
      const tempData = {
        bookingAddon: tempAddon,
        secretKey: requests.apiKey,
      };
      // console.log(`${JSON.stringify(tempData, null, 2)}`);
      axios
        .post(requests.checkAddonBarcodeAvailability, tempData)
        .then((response) => {
          //  console.log(`${JSON.stringify(response.data, null, 2)}`);

          //  console.log("response.data", response.data);
          if (response.data.errorCode == 600) {
            settempErr(true);
          } else if (response.data.errorCode == 601) {
            settempErr(true);
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      let finalprice = Number(addonPrice) - Number(newprice);
      setaddonPrice(finalprice);
      let temp = bookingAddon.filter((item) => item.addonId != val);
      setbookingAddon(temp);
    }
  };

  const [tktAvailability, settktAvailability] = useState(0);
  const [servserRes, setservserRes] = useState();
  const [showTktFare, setshowTktFare] = useState(0);
  const [actAdultfare, setactAdultfare] = useState();
  const [actChildfare, setactChildfare] = useState();
  const [setEventIdErr, setsetEventIdErr] = useState(false);
  const [eveId, seteveId] = useState("");
  const [resId, setresId] = useState("");
  const [ticketName, setticketName] = useState();

  // const tooltip = (
  //   <Tooltip id="tooltip">
  //     <strong>Holy guacamole!</strong> Check this info.
  //   </Tooltip>
  // );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [childTooltipOpen, setchildTooltipOpen] = useState(false);
  const [adultTooltipOpen, setadultTooltipOpen] = useState(false);
  const [adultExpiry, setadultExpiry] = useState("");
  const [childExpiry, setchildExpiry] = useState("");

  const childtoggle = () => {
    setchildTooltipOpen(!childTooltipOpen);
  };
  const adulttoggle = () => {
    setadultTooltipOpen(!adultTooltipOpen);
  };

  const [fullTicketData, setfullTicketData] = useState();
  const [adultClicked, setadultClicked] = useState(false);
  const [childClicked, setchildClicked] = useState(false);

  const handleFieldClickChild = () => {
    setchildClicked(true);
  };
  const handleFieldClickAdult = () => {
    setadultClicked(true);
  };

  // Ticket timeslot



  return (
    <>
      <TopNav  />
      <DynamicBanner
        imgUrl={requests.imgpath + tourpack.attBannerImage}
        title={tourpack.attName}
      />
      <div className="tour-details-area mg-top--70">
        <div className="tour-details-gallery">
          <div className="container-bg bg-dark-blue">
            <div className="container">
              <div className="row">
                <div className="col-xl-3 col-lg-4">
                  <div className="details">
                    <p className="location mb-0">
                      <i className="fa fa-map-marker" />
                      {tourpack.attCity}
                    </p>
                    <h4 className="title">{tourpack.attName}</h4>
                  </div>
                </div>
                <div className="col-xl-9 col-lg-8">
                  <div className="book-list-warp">
                    <p className="book-list-content">
                      Just booked! Get your spot before it's too late.
                    </p>
                    <div className="tp-price-meta">
                      {/* <p>Price</p>
                      <h2>
                        {LoggedIn == 1
                          ? tourpack.b2bAdultPrice
                          : tourpack.b2cAdultPrice}
                        &nbsp;&nbsp;&nbsp;
                        <small>AED</small>
                      </h2> */}

                      {login === "yes" && (
                        <Row>
                          <Col>
                            <p>
                              Adult Price <h2>{tourpack.adultPrice}</h2>
                            </p>{" "}
                            &nbsp;&nbsp;&nbsp;<small>AED</small>
                          </Col>
                          <Col>
                            <p>
                              Child Price <br />
                              <h2>{tourpack.childPrice}</h2>
                            </p>{" "}
                            &nbsp;&nbsp;&nbsp;<small>AED</small>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </div>
                  <ul className="tp-list-meta border-tp-solid">
                    {isBannerLoading ? (
                      <>Loading ...</>
                    ) : (
                      <>
                        {bannerAddOn.map((banner, index) => (
                          <li key={index}>
                            <i className={banner.addonIcon} />{" "}
                            {banner.addonType} &nbsp; - &nbsp;
                            {banner.addonValue}
                          </li>
                        ))}
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          {isLoading ? (
            <>Loading...</>
          ) : (
            <>
              <Row>
                <Col sm={8}>
                  <br />
             
                  <CardBody>
                    <Carousel
                      // showArrows={true}
                      // showThumbs={true}
                      // transitionTime={10000}
                      autoPlay={true}
                      infiniteLoop={true}
                    >
                      {tourpack.filesStorage
                        .filter((item) => item.platformId === 1)
                        ?.map((tourImage, index) => (
                          // slice(0,10 )
                          <div
                            className="tp-gallery-item col-lg-12 "
                            // className="carousal-img-size"
                            key={index}
                          >
                            <div className="tp-gallery-item-img">
                              <a href="#" data-effect="mfp-zoom-in">
                                <img
                                  height="300"
                                  width="100%"
                                  src={requests.imgpath + tourImage.fileName}
                                  alt="image"
                                />
                              </a>
                            </div>
                          </div>
                        ))}
                    </Carousel>

                    <div className="tour-details-wrap">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <h4 className="single-page-small-title">
                          {tourpack.attName}
                        </h4>
                        {id === "15" && (
                          <div>
                            <a
                              href="https://b2b.parmartours.com/filestorage/EEG-product-description.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "red",
                                fontSize: "20px",
                                cursor: "pointer",
                                fontWeight: "bold",
                              }}
                            >
                              {" "}
                              Product Description
                            </a>
                          </div>
                        )}
                      </div>

                      <p>
                        {" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: tourpack.attDescription,
                          }}
                        />
                      </p>
                    </div>
                  </CardBody>
                </Col>

                <Col sm={4}>
                  <div className="fixed-content">
                    <Card>
                      <CardHeader>
                        {" "}
                        <h3
                          className="single-page-small-title"
                          // onClick={() => {
                          //   Swal.fire("Error", "Token expired", "error");
                          // }}
                        >
                          Book Now
                        </h3>
                      </CardHeader>
                      <CardBody>
                        <Form>
                          {LoggedIn == 1 ? (
                            <>
                              {userdata.b2b == true ||
                              userdata.b2bUser == true ? (
                                <>
                                  {/* {
                                  userdata.agency == ""?<>{console.log("Nilllll")}</>:<></>
                                } */}{" "}
                                  {userdata.b2b == true &&
                                  userdata.agency.superAdmin == true ? (
                                    <>
                                      <Field
                                        name="BookForAgent"
                                        component={
                                          RenderField.RendercheckboxField
                                        }
                                        label="Book For Agent"
                                        onChange={(e) => {
                                          setShowOption(e.target.checked);
                            
                                         
                       
                                        }}
                                      />
                                      {showOption === true ? (
                                        <>
                                          {/* <label>Select Agent</label> */}
                                          {/* <Select
                                            options={agentList}
                                            onChange={(e) =>
                                              setagentIdForBook(e.value)
                                            }
                                          /> */}

                                          <Field
                                            name="agentIdForBookfromSuperAdmin"
                                            label="Select Agent"
                                            options={[]}
                                           
                                            component={
                                              RenderField.RenderSelectField
                                            }
                                          />

                                          <span
                                            style={{
                                              color: "red",
                                            }}
                                          >
                                            Available Balance:-
                                         
                                          </span>

                                          <br />
                                          {agency === 268 && (
                                            <Row>
                                              <Col>
                                                <Field
                                                  name="bookedCredit"
                                                  component="input"
                                                  type="radio"
                                                  value="1"
                                                  checked="checked"
                                                  onChange={(e) =>
                                                    setUserCredit(
                                                      e.target.value
                                                    )
                                                  }
                                                />{" "}
                                                Agent Credit
                                              </Col>

                                              <Col>
                                                <Field
                                                  name="bookedCredit"
                                                  component="input"
                                                  type="radio"
                                                  value="2"
                                                  onChange={(e) =>
                                                    setUserCredit(
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                Super User Credit
                                              </Col>
                                            </Row>
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : null}
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : null}

                          <Field
                            name="attractionsId"
                            type="hidden"
                            icon=""
                            component={RenderField.RenderTextField}
                          />
                          {id == "147" ? (
                            <Row>
                              <Col>
                                <Field
                                  name="firstName"
                                  type="text"
                                  label="First Name"
                                  // onChange={(e) => setfName(e.target.value)}
                                  component={RenderField.RenderTextField}
                                />
                              </Col>
                              <Col>
                                <Field
                                  name="lastName"
                                  type="text"
                                  label="Last Name"
                                  // onChange={(e) => setlName(e.target.value)}
                                  component={RenderField.RenderTextField}
                                />
                              </Col>
                            </Row>
                          ) : (
                            <Field
                              name="bookCustomerName"
                              type="text"
                              placeholder="Optional"
                              label="Lead Passenger Name"
                              component={RenderField.RenderTextField}
                            />
                          )}

                          <Field
                            name="bookCustomerEmail"
                            type="email"
                            placeholder="Optional"
                            label="Email Address"
                            // onChange={(e) => setuserEmail(e.target.value)}
                            component={RenderField.RenderTextField}
                          />
                          <Field
                            name="bookMobileNumber"
                            type="text"
                            label="Contact Number"
                            component={RenderField.RenderTextField}
                          />

                          {tourpack.openTicketOption == true &&
                            tourpack.attConnectWithApi && (
                              <>
                                {LoggedIn == 1 ? (
                                  <>
                                    {userdata.b2b == true ||
                                    userdata.b2bUser == true ? (
                                      <>
                                        {" "}
                                        <div className="single-widget-search-input-title">
                                          <i className=" " /> Select Ticket Type
                                        </div>
                                        <Row>
                                          <Col>
                                            <Field
                                              name="openTkt"
                                              component="input"
                                              type="radio"
                                              value="1"
                                              onChange={(e) =>
                                                setOpenTicket(e.target.value)
                                              }
                                            />{" "}
                                            Open Ticket
                                          </Col>
                                          <Col>
                                            <Field
                                              name="openTkt"
                                              component="input"
                                              type="radio"
                                              value="2"
                                              onChange={(e) =>
                                                setOpenTicket(e.target.value)
                                              }
                                            />{" "}
                                            Dated Ticket
                                          </Col>
                                        </Row>
                                      </>
                                    ) : null}
                                  </>
                                ) : null}
                              </>
                            )}

                          {tourpack.attConnectWithApi == true ? (
                            <>
                              {LoggedIn == 1 &&
                              tourpack.openTicketOption === true ? (
                                <>
                                  {userdata.b2b == true ||
                                  userdata.b2bUser == true ? (
                                    <>
                                      {OpenTicket == 1 || OpenTicket == 2 ? (
                                        <>
                                          <Field
                                            name="ticketTypeId"
                                            type="select"
                                            customfeild={
                                              ticketTypeList
                                            }
                                            label="Ticket Type"
                                         
                                            component={
                                              renderTicketTypeField
                                            }
                                          />
                                          {tktAvailability == 1 ? (
                                            <Alert color="primary">
                                              {servserRes}
                                            </Alert>
                                          ) : null}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <Field
                                        name="ticketTypeId"
                                        type="select"
                                        customfeild={ticketTypeList}
                                        label="Ticket Type"
                                    
                                        component={
                                          renderTicketTypeField
                                        }
                                      />
                                      {tktAvailability == 1 ? (
                                        <Alert color="primary">
                                          {servserRes}
                                        </Alert>
                                      ) : null}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <Field
                                    name="ticketTypeId"
                                    type="select"
                                    customfeild={ticketTypeList}
                                    label="Ticket Type"
                                   
                                    component={renderTicketTypeField}
                                  />
                                  {tktAvailability == 1 ? (
                                    <Alert color="primary">{servserRes}</Alert>
                                  ) : null}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <Field
                                name="ticketTypeId"
                                type="select"
                                 customfeild={ticketTypeList}
                                label="Ticket Type"
                              
                                component={renderTicketTypeField}
                              />
                            </>
                          )}

                          {false && (
                            <Row>
                            <Col>
                              <Field
                                name="bookNofAdult"
                                type="text"
                                label="Adult"
                                predefindvalue={
                                  numOfAdult === 0 ? "" : numOfAdult
                                }
                                disabled={
                                  adultClicked === true &&
                                  fullTicketData?.errorCode === 505 &&
                                  true
                                }
                                onClick={handleFieldClickAdult}
                                onChange={(e) => {
                                  setnumOfAdult(e.target.value);
                                
                                
                                }}
                                // onChange={(e) =>
                                //   amountCalculation(e.target.value)
                                // }
                                component={RenderField.RenderTextField}
                              />
                              {adultClicked === true &&
                                fullTicketData?.errorCode === 505 && (
                                  <span
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    Ticket Not Available
                                  </span>
                                )}
                              {showTktFare == 1 ? (
                                LoggedIn == 1 ? (
                                  <>
                                    {userdata.b2b == true ||
                                    userdata.b2bUser == true ? (
                                      <>
                                        {" "}
                                        {adultfare}
                                        <del>
                                          <small>{actAdultfare}</small>
                                        </del>
                                      </>
                                    ) : (
                                      adultfare
                                    )}
                                  </>
                                ) : (
                                  adultfare
                                )
                              ) : null}{" "}
                              <br />
                              <span style={{ color: "red", fontSize: "12px" }}>
                                {" "}
                                {adultExpiry}
                              </span>
                            </Col>
                            <Col>
                              <Field
                                name="bookNofChild"
                                type="text"
                                label="Child"
                                predefindvalue={
                                  numOfChild === 0 ? "" : numOfChild
                                }
                                disabled={
                                  ((childClicked === true &&
                                    fullTicketData?.errorCode === 504) ||
                                    seletedTicketId == 480 ||
                                    seletedTicketId == 436) &&
                                  true
                                }
                                onClick={handleFieldClickChild}
                                onChange={(e) => {
                                  setnumOfChild(e.target.value);
                             
                                 
                                }}
                                component={RenderField.RenderTextField}
                              />
                              {childClicked === true &&
                                fullTicketData?.errorCode === 504 && (
                                  <span
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    Child Ticket Not Available
                                  </span>
                                )}
                              {(seletedTicketId == 480 ||
                                seletedTicketId == 436) && (
                                <span
                                  style={{ color: "red", fontSize: "12px" }}
                                >
                                  Child Ticket Not Available
                                </span>
                              )}
                              {/* {childClicked === true &&
                                fullTicketData?.errorCode === 505 && (
                                  <span
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    Ticket Not Available
                                  </span>
                                )} */}
                              {showTktFare == 1 ? (
                                LoggedIn == 1 ? (
                                  <>
                                    {userdata.b2b == true ||
                                    userdata.b2bUser == true ? (
                                      <>
                                        {childfare}
                                        <del>
                                          <small>{actChildfare}</small>
                                        </del>
                                      </>
                                    ) : (
                                      childfare
                                    )}
                                  </>
                                ) : (
                                  childfare
                                )
                              ) : null}{" "}
                              <br />
                              <span style={{ color: "red", fontSize: "12px" }}>
                                {childExpiry}{" "}
                              </span>
                              {/* {childExpiry != "" && (
                                <>
                                  <i
                                    className="fa fa-info-circle"
                                    aria-hidden="true"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    id="childExpiry"
                                  />
                                  <Tooltip
                                    placement="right"
                                    isOpen={childTooltipOpen}
                                    target="childExpiry"
                                    toggle={childtoggle}
                                  >
                                    {childExpiry}
                                  </Tooltip>
                                </>
                              )} */}
                            </Col>

                            {id != 174 && (
                              <Col>
                                <Field
                                  name="bookNofInfant"
                                  type="text"
                                  label="Infant"
                                  predefindvalue={
                                    numOfInfant === 0 ? "" : numOfInfant
                                  }
                                  onChange={(e) => {
                                    setumOfInfant(e.target.value);
                                  
                                  
                                  }}
                                  component={RenderField.RenderTextField}
                                />
                                {showTktFare == 1 ? (
                                  LoggedIn == 1 ? (
                                    <>
                                      {userdata.b2b == true ||
                                      userdata.b2bUser == true ? (
                                        <>{infantFare}</>
                                      ) : (
                                        infantFare
                                      )}
                                    </>
                                  ) : (
                                    infantFare
                                  )
                                ) : null}{" "}
                              </Col>
                            )}

                            {id == 174 && (
                              <Col>
                                <Field
                                  name="bookNofYouth"
                                  type="text"
                                  label="Youth"
                                  predefindvalue={
                                    numOfYouth === 0 ? "" : numOfYouth
                                  }
                                  disabled={youthfare === 0 && true}
                                 
                                  component={RenderField.RenderTextField}
                                />
                                {youthfare}
                              </Col>
                            )}
                          </Row>
                          )}

                          {/* for youth */}

                          <br />

                          {/* <Field
                            name="bookTravellDate"
                            type="date"
                            label="Travel Date"
                            onChange={(e) => checkTimeSlot(e.target.value)}
                            component={RenderField.RenderDateField}
                            className="form-control"
                          /> */}

                          <div>
                            <Field
                              name="bookTravellDate"
                              type="date"
                              label="Travel Date"
                              minDate={new Date()}
                              // holydays={holydays}
                              // enabledDates={(id == '2' || id == '8') && enabledDates}
                              component={renderDatePickerWithTimeSlot}
                              className="form-control"
                            />
                            {/* Debug button to test API call */}
                            <Button
                              color="link"
                              size="sm"
                              onClick={() => {
                                console.log("Manual test button clicked");
                                console.log("selectedTicketType:", selectedTicketType);
                                console.log("seletedTicketId:", seletedTicketId);
                                console.log("selectedTravelDate:", selectedTravelDate);
                                if (selectedTicketType && selectedTicketType.fullData) {
                                  const productId = selectedTicketType.fullData.productId || selectedTicketType.fullData.ProductId;
                                  console.log("Manual test - ProductId:", productId);
                                  if (productId && selectedTravelDate) {
                                    console.log("Manual test - Calling API");
                                    getBurjKhalifaTimeSlots(selectedTravelDate, productId);
                                  } else {
                                    alert("Please select both ticket type and travel date first");
                                  }
                                } else {
                                  alert("Please select a ticket type first. ProductId: " + (selectedTicketType?.fullData?.productId || "not found"));
                                }
                              }}
                              style={{ fontSize: '10px', padding: '2px 5px' }}
                            >
                              (Debug: Test API Call)
                            </Button>
                          </div>
                          
                          {/* Time Slots Display */}
                          {isLoadingTimeSlots && (
                            <div className="mt-2">
                              <small>Loading time slots...</small>
                            </div>
                          )}
                          
                          {!isLoadingTimeSlots && timeSlots.length > 0 && (
                            <div className="mt-3">
                              <div className="single-widget-search-input-title">
                                <i className="" /> Available Time Slots
                              </div>
                              <div 
                                className="time-slots-container" 
                                style={{ 
                                  display: 'grid', 
                                  gridTemplateColumns: 'repeat(2, 1fr)', 
                                  gap: '10px', 
                                  marginTop: '10px' 
                                }}
                              >
                                {timeSlots.map((slot, index) => {
                                  // Determine color based on availability
                                  const available = slot.Available || 0;
                                  let borderColor = '#dc3545'; // Red - No availability
                                  let backgroundColor = '#fff';
                                  let textColor = '#dc3545';
                                  
                                  if (available > 20) {
                                    borderColor = '#28a745'; // Green - Good availability
                                    backgroundColor = '#f8fff9';
                                    textColor = '#28a745';
                                  } else if (available > 5) {
                                    borderColor = '#ffc107'; // Yellow - Low availability
                                    backgroundColor = '#fffef8';
                                    textColor = '#856404';
                                  } else if (available > 0) {
                                    borderColor = '#fd7e14'; // Orange - Very low availability
                                    backgroundColor = '#fff8f3';
                                    textColor = '#c05621';
                                  }
                                  
                                  const isSelected = selectedSlotEventId === slot.EventID;
                                  return (
                                    <div
                                      key={index}
                                      style={{ 
                                        border: `2px solid ${isSelected ? '#0d6efd' : borderColor}`,
                                        backgroundColor: isSelected ? '#e7f1ff' : backgroundColor,
                                        color: isSelected ? '#0d6efd' : textColor,
                                        borderRadius: '4px',
                                        padding: '12px 8px',
                                        textAlign: 'center',
                                        cursor: available > 0 ? 'pointer' : 'not-allowed',
                                        opacity: available > 0 ? 1 : 0.6,
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        minHeight: '60px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        transition: 'all 0.2s ease',
                                        boxShadow: isSelected ? '0 0 0 3px rgba(13,110,253,0.25)' : 'none'
                                      }}
                                      onClick={available > 0 ? () => {
                                        console.log('Time slot selected:', slot);
                                        setSelectedSlotEventId(slot.EventID);
                                        getBurjKhalifaTicketTypes(slot);
                                      } : undefined}
                                    >
                                      <div style={{ lineHeight: '1.4' }}>
                                        {formatTimeSlot(slot.StartDateTime, slot.EndDateTime)}
                                      </div>
                                      {available > 0 && (
                                        <small style={{ 
                                          display: 'block', 
                                          fontSize: '11px', 
                                          marginTop: '4px',
                                          opacity: 0.8
                                        }}>
                                          ({available} available)
                                        </small>
                                      )}
                                      {available === 0 && (
                                        <small style={{ 
                                          display: 'block', 
                                          fontSize: '11px', 
                                          marginTop: '4px',
                                          opacity: 0.8
                                        }}>
                                          (Unavailable)
                                        </small>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}

                          {
                            <>
                              <br />
                              <div className="single-widget-search-input-title">
                                <i className=" " /> Enter Quantities
                              </div>
                              <Row>
                                <Col>
                                  <Field
                                    name="bookNofAdult"
                                    type="number"
                                    label="Adult"
                                    predefindvalue={numOfAdult === 0 ? "" : numOfAdult}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      const n = val === "" ? 0 : Math.max(0, parseInt(val || 0));
                                      setnumOfAdult(isNaN(n) ? 0 : n);
                                    }}
                                    component={RenderField.RenderTextField}
                                  />
                                  {slotAdultPrice !== null && (
                                    <small style={{ display: 'block', marginTop: '4px' }}>
                                      AED {slotAdultPrice}
                                    </small>
                                  )}
                                </Col>
                                <Col>
                                  <Field
                                    name="bookNofChild"
                                    type="number"
                                    label="Child"
                                    predefindvalue={numOfChild === 0 ? "" : numOfChild}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      const n = val === "" ? 0 : Math.max(0, parseInt(val || 0));
                                      setnumOfChild(isNaN(n) ? 0 : n);
                                    }}
                                    component={RenderField.RenderTextField}
                                  />
                                  {slotChildPrice !== null && (
                                    <small style={{ display: 'block', marginTop: '4px' }}>
                                      AED {slotChildPrice}
                                    </small>
                                  )}
                                </Col>
                              </Row>
                            </>
                          }
                          
                          {!isLoadingTimeSlots && timeSlots.length === 0 && selectedTravelDate && selectedTicketType && (
                            <div className="mt-2">
                              <small style={{ color: '#666' }}>No time slots available for this date</small>
                            </div>
                          )}
                          
                          <br />
                          {setEventIdErr && (
                            <Alert color="primary">
                              Select Your Ticket Type
                            </Alert>
                          )}



                         

                        
                          <Field
                            name="agentRefNumber"
                            type="text"
                            label="Agent Reference Number"
                            component={RenderField.RenderTextField}
                            className="form-control"
                          />

                          {showOption === true && (
                            <Field
                              name="bookCompanyReference"
                              type="text"
                              label="Company Reference"
                              component={RenderField.RenderTextField}
                              className="form-control"
                            />
                          )}

                          <br />
                   ``

                          <Label>
                            Total Fare &nbsp;&nbsp;&nbsp; : &nbsp;
                            {
                              showQtyBelowSlots
                                ? Number(
                                    (slotAdultPrice || 0) * (numOfAdult || 0) +
                                    (slotChildPrice || 0) * (numOfChild || 0)
                                  )
                                : Number(
                                    adultfare * (numOfAdult || 0) +
                                    childfare * (numOfChild || 0) +
                                    addonPrice * (numOfAdult || 0) +
                                    addonPrice * (numOfChild || 0) +
                                    infantFare * (numOfInfant || 0) +
                                    youthfare * (numOfYouth || 0)
                                  )
                            }
                            &nbsp;
                          </Label>

                          {/* <Label>
                            Total Fare &nbsp;&nbsp;&nbsp; : &nbsp;
                            {id == 147 ? (
                              <>{mofCartData?.totalAmount} </>
                            ) : (
                              Number(
                                adultfare * numOfAdult +
                                  childfare * numOfChild +
                                  addonPrice * numOfAdult +
                                  addonPrice * numOfChild
                              )
                            )}
                            &nbsp;
                          </Label> */}

                          <br />

                          {LoggedIn == 1 ? (
                            <>
                              {userdata.b2b == true ||
                              userdata.b2bUser == true ? (
                                <>
                                  {showOption === true ? null : (
                                    <>
                                      <div className="single-widget-search-input-title">
                                        <i className=" " /> Payment Method
                                      </div>
                                      <Row>
                                        <Col>
                                          <Field
                                            name="bookPaymentMode"
                                            component="input"
                                            type="radio"
                                            checked="checked"
                                            value="1"
                                            //  onChange={(e) => settktType(e.target.value)}
                                          />{" "}
                                          Online
                                        </Col>
                                        <Col>
                                          <Field
                                            name="bookPaymentMode"
                                            component="input"
                                            type="radio"
                                            value="2"
                                            //  onChange={(e) => settktType(e.target.value)}
                                          />{" "}
                                          Credit
                                          {insuffBal == 1 ? (
                                            <>
                                              {" "}
                                              <Alert color="primary">
                                                insufficient Balance
                                              </Alert>
                                            </>
                                          ) : null}
                                        </Col>
                                      </Row>
                                      {paymentSelection == 1 ? (
                                        <>
                                          {" "}
                                          <Alert color="primary">
                                            Select Payment Method
                                          </Alert>
                                        </>
                                      ) : null}
                                      <br />
                                    </>
                                  )}
                                 
                                  <div className="d-flex justify-content-end">
                                    <Button
                                      color="primary"
                                      className="btn btn-yellow"
                                      type="button"
                                      onClick={() => {
                                        if (sessionStorage.getItem("isLoggedIn") === "yes") {
                                          handleBookNow();
                                        } else {
                                          history.push("/login-page");
                                        }
                                      }}
                                      
                                    >
                                      Book Now
                                    </Button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="d-flex justify-content-end">
                                    {/* <Button
                                  color='primary'
                                  type='submit'
                                  className='btn btn-yellow'
                                  disabled={submitting}>
                                  Book Now
                                </Button> */}
                                    <Button
                                      color="primary"
                                      className="btn btn-yellow"
                                      type="button"
                                      onClick={() => {
                                        if (sessionStorage.getItem("isLoggedIn") === "yes") {
                                          handleBookNow();
                                        } else {
                                          history.push("/login-page");
                                        }
                                      }}
                                    >
                                      Book Now
                                    </Button>
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="d-flex justify-content-end">
                                {/* <Button
                                  color='primary'
                                  type='submit'
                                  className='btn btn-yellow'
                                  disabled={submitting}>
                                  Book Now
                                </Button> */}
                                <Button
                                  color="primary"
                                  className="btn btn-yellow"
                                  type="button"
                                  onClick={() => {
                                    if (sessionStorage.getItem("isLoggedIn") === "yes") {
                                      handleBookNow();
                                    } else {
                                      history.push("/login-page");
                                    }
                                  }}
                                >
                                  Book Now
                                </Button>
                              </div>
                            </>
                          )}
                        </Form>
                      </CardBody>
                      {/* <CardFooter></CardFooter>  */}
                    </Card>
                  </div>

                  <div>
                    <br />
                    <br />
                  </div>
                  <CardBody>
                    <div className="contact">
                      {" "}
                      <div className="text-lg-center ">
                        <p>
                          {" "}
                          <div className="anger-text">Enquiry</div>
                        </p>
                      </div>
                    </div>
                    <br />
                    <Row>
                      <Col sm={6}>
                        <br />
                        <img
                          src={publicUrl + "assets/img/callORwhatsapp.gif"}
                          height="150px"
                          width="150px"
                          alt="whatsapp"
                        />
                      </Col>

                      <Col sm={6}>
                        <b>
                          <b>Park Ticket </b>
                          <p> +971 52 909 3077</p>
                          <p> +971 52 909 3078</p>
                          <p> +971 52 909 3079</p>
                          <p> +971 52 909 3081</p>
                          <b>Tourist Visa</b>
                          <p> +971 52 909 3082</p>
                          <b>Tour Package</b>
                          <p> +971 52 909 3076</p>
                        </b>
                      </Col>
                    </Row>
                    <hr />

                    <Row>
                      <Col sm={2}></Col>
                      {/* <Col sm={2}>
                        <p></p>
                      </Col> */}
                      <Col sm={5}>
                        <br />
                        <b>
                          <b>WEB SUPPORT </b>

                          <p> +971 50 421 7788</p>
                        </b>
                      </Col>
                      <Col sm={5}>
                        <img
                          src={publicUrl + "assets/img/helpline.gif"}
                          height="150px"
                          width="150px"
                          alt="helpline"
                        />
                      </Col>
                    </Row>
                    <div className="contact">
                      {" "}
                      <div class="text-lg-center">
                        <a
                          href="mailto: parmar@parmartours.com"
                          className="anger-text"
                        >
                          {" "}
                          Click and Send&nbsp;&nbsp;
                          <i
                            className="fa fa-envelope-o fa-1x"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </CardBody>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>

      <div>
        <div className="container">
          <h4 className="single-page-small-title">You May Also Like</h4>
          <Attractionbygroup attList={attractionList} />
        </div>
      </div>
      <Subscribe />

      <Footer />
    </>
  );
};
export default reduxForm({
  form: "TicketBookingFormapi",
  // asyncBlurFields: ["bookCustomerName"],

})(Packdetailapi);
